import { atom } from 'jotai';

const LoadingStore = atom<boolean>(false);

export default LoadingStore;
